import React, { useState } from 'react';
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import Container from '../components/Container';
import { Desktop, Tablet } from '../constants/responsive';
import { css } from '@emotion/core';
import { useIntl } from 'gatsby-plugin-intl';
import { useStaticQuery, graphql } from 'gatsby';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import ProductDetailsCarousel from '../components/ProductDetailsCarousel';
import BackTestingPic from '../components/BackTestingPic';
import ProductDetailsBoxes from '../components/ProductDetailsBoxes';
import CardContent from '../components/ProductDetailsCardContent';
import { PicBox1 } from '../components/ProductDetailsPicBox';
import OtherBenefits from '../components/ProductDetailsOtherBenefits';
import Suitable from '../components/ProductDetailsSuitable';
import Tag from '../components/ProductDetailsTag';
import { useUpdateEffect } from 'react-use';
import HowItWorks from '../components/ProductDetailsHowItWorks';
import SignUpSuccessPopup from '../components/SignUpSuccessPopup';
import ProductDetailsRiskSlider from '../components/ProductDetailsRiskSlider';

// 全债避风港和LongTerm系列
const ProductDetails = ({ pageContext }) => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      SmartGlobal: file(relativePath: { eq: "individuals/SmartGlobal.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      SmartGlobalMax: file(
        relativePath: { eq: "individuals/SmartGlobal-Max.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      SmartGlobalX: file(relativePath: { eq: "individuals/SmartGlobalX.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      DefensivePortfolio: file(
        relativePath: { eq: "individuals/Defensive-Portfolio.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      allProduct {
        edges {
          node {
            product_id
            riskType
            locale
            data {
              pid
              algo_type_id
              market
              category
              edition
              currency
              product_name
              product_logo
              min_investment_amount
              tags
              tags_detail_page
              backtesting {
                date
                value
              }
              benchmark {
                date
                value
              }
              description_card_1 {
                description
                prefix_1
                metric_1
                sub_title
                title
                value_1
              }
              description_card_2 {
                description
                sub_title
                title
                factors {
                  content
                  image
                  image_official
                  name
                }
              }
              description_card_3 {
                description
                metric_1
                metric_2
                prefix_1
                prefix_2
                sub_title
                title
                value_1
                value_2
              }
            }
          }
        }
      }
    }
  `);
  const [riskType, setRiskType] = useState(pageContext.riskType);
  const products = data.allProduct.edges
    .map((node) => node.node)
    .map((product) => {
      return {
        ...product,
        factors: product.data.description_card_2.factors,
      };
    })
    .filter((product) => product.locale === intl.locale)
    .filter((product) => {
      return (
        product.riskType === riskType &&
        (product.product_id === pageContext.pid ||
          product.data.product_name + ' Basic' === pageContext.productName ||
          pageContext.productName + ' Basic' === product.data.product_name)
      );
    });
  // 上面filter的最后一个条件的针对长期分散组合系列的，入门版和标准版
  var combinationName = `pid-${products[0].product_id}`;
  if (products.length > 1) {
    if (
      products[0].data.min_investment_amount >
      products[1].data.min_investment_amount
    ) {
      [products[0], products[1]] = [products[1], products[0]];
    }
    combinationName = `pid-${products[0].product_id}-${products[1].product_id}`;
  }
  const [product, setProduct] = useState(products[0]);

  const [yearlyReturn, setYearlyReturn] = useState(0); // 累计收益率
  const [remarks, setRemarks] = useState(0); // 基准
  const [maxDrawDown, setMaxDrawDown] = useState(0); // 最大回撤

  const type = product.product_id === 3000 ? 'stable-and-liquid' : 'long-term';
  const logo = intl.formatMessage({
    id: `productDetails.${combinationName}.logo`,
  });
  // 从logo中截出imgName并转成驼峰命名形式
  const imgName = logo
    .slice(logo.lastIndexOf('/') + 1, logo.lastIndexOf('.'))
    .replace(/-/g, '');

  var showRiskSlider = true;
  if (product.product_id === 3000) {
    showRiskSlider = false;
  }
  // 监听selectedRisk的改变
  useUpdateEffect(() => {
    setProduct(products[0]);
  }, [riskType]);
  return (
    <Layout footerForm footerBand={false}>
      <SEO
        title={intl.formatMessage({
          id: `productDetails.${combinationName}.SEO.title`,
        })}
        description={intl.formatMessage({
          id: `productDetails.${combinationName}.SEO.description`,
        })}
        keywords={intl.formatMessage({
          id: `productDetails.${combinationName}.SEO.keywords`,
        })}
      />
      <SignUpSuccessPopup />
      <Container
        css={css`
          display: flex;
          flex-direction: column;
          ${Tablet} {
            padding: 0 60px 0 60px;
          }
          ${Desktop} {
            display: block;
            padding: 0 20px 0 20px;
          }
        `}
      >
        {/* 顶部图片标题等 */}
        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
            ${Tablet} {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
            }
            ${Desktop} {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
            }
          `}
        >
          <div
            css={css`
              width: 100%;
              ${Tablet} {
                width: fit-content;
              }
            `}
          >
            <div
              css={css`
                border-radius: 50%;
                background: ${`url(${data[imgName].childImageSharp.fluid.src})`}
                  center/auto 100% no-repeat border-box border-box;
                background-size: cover;
                width: 65px;
                height: 65px;
                margin: 26px 170px 8.1px 0px;
                ${Tablet} {
                  width: 90px;
                  height: 90px;
                  margin: 49px 20px 0 0px;
                }
                ${Desktop} {
                  width: 145px;
                  height: 146px;
                  margin: 28px 19px 21.6px 0px;
                }
              `}
            ></div>
          </div>

          <div
            css={css`
              font-weight: bold;
              text-align: left;
              color: #000000;
              width: fit-content;
              margin: 8.1px 24.3px 20px 0px;
              font-size: 30px;
              line-height: 1.17;
              ${Tablet} {
                width: fit-content;
                font-size: 35px;
                margin: 54px 0px 3px 0px;
                line-height: 0.5;
              }
              ${Desktop} {
                width: fit-content;
                height: 70px;
                margin: 65px 0px 60.6px 0px;
                font-size: 50px;
                line-height: 1.3;
              }
            `}
          >
            <div
              css={css`
                display: flex;
                align-items: center;
              `}
            >
              <div
                css={css`
                  line-height: 1;
                `}
              >
                {product.data.product_name}
              </div>
              <span
                css={css`
                  display: block;
                  background-color: #9190de;
                  border-radius: 2px;
                  color: #ffffff;
                  width: fit-content;
                  font-size: 15px;
                  font-weight: normal;
                  text-align: center;

                  height: 18px;
                  line-height: 18px;
                  margin-left: 11.7px;

                  padding: 0 1px 4px 3px;
                  ${Tablet} {
                    height: 18px;

                    padding: 0 1px 4px 3px;
                  }
                  ${Desktop} {
                    padding: 0.5px 3px;
                  }
                `}
              >
                {product.data.market}
              </span>
            </div>

            <div
              css={css`
                margin-top: 2px;
                display: flex;
              `}
            >
              <Tag
                text={intl.formatMessage({
                  id: `productDetails.${combinationName}.tag-1`,
                })}
              />
              <Tag
                text={intl.formatMessage({
                  id: `productDetails.${combinationName}.tag-2`,
                })}
              />
            </div>
          </div>
        </div>

        <div
          css={css`
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            ${Desktop} {
              flex-direction: row;
              align-items: flex-start;
            }
          `}
        >
          {/* 【风险条】：pid为32，33的产品有风险条 */}
          {product.data.pid < 100 && (
            <ProductDetailsRiskSlider
              riskType={riskType - 1}
              setRiskType={setRiskType}
            />
          )}

          {/* 左-回测图 */}
          <BackTestingPic
            backtesting={product.data.backtesting}
            benchmark={product.data.benchmark}
            productName={product.data.product_name}
            benchmarkName={`productDetails.${combinationName}.benchmark-name`}
            combinationName={combinationName}
            setRemarks={setRemarks}
            setYearlyReturn={setYearlyReturn}
            setMaxDrawDown={setMaxDrawDown}
            riskType={riskType}
            product={product}
          />
          {/* 右-标准版，进阶版内容-三个盒子 */}
          {/* 全债避风港和LongTerm系列不显示组合内前3支股票 */}
          <ProductDetailsBoxes
            showStandard
            productData={product.data}
            showBoxThree={false}
            firstButtonData={`productDetails.${combinationName}.basic`}
            secondButtonData={`productDetails.${combinationName}.standard`}
            yearlyReturn={yearlyReturn}
            remarks={remarks}
            maxDrawDown={maxDrawDown}
            productId={product.data.pid}
            showRiskSlider={showRiskSlider}
          />
        </div>

        {/* 左-字 */}
        <CardContent
          style={{ display: 'inline-block' }}
          data={`productDetails.${combinationName}.card-1`}
          longTermData
        />

        {/* 右-图 */}
        <div
          css={css`
            display: block;
            ${Tablet} {
              align-self: center;
            }
            ${Desktop} {
              display: inline-block;
            }
          `}
        >
          <PicBox1
            data={`productDetails.${combinationName}`}
            type={type}
            img={data[imgName].childImageSharp.fluid.src}
          />
        </div>

        {/* 适合人群 */}
        <Suitable data={`productDetails.${combinationName}.suitable`} />

        {/* 精准数据分析 */}
        <HowItWorks data={`productDetails.how-it-works`} />

        {/* 其他优势 */}
        <OtherBenefits data={`productDetails.other-benefits`} />

        {/* 其他组合 */}
        {/* <Container
          css={css`
            padding: 0;
            margin-bottom: 100px;
            display: flex;
            flex-direction: column;
            margin-top: 80px;
            ${Tablet} {
              width: 100%;
            }
            ${Desktop} {
              margin-top: 140px;
            }
          `}
        >
          <div
            css={css`
              font-weight: bold;

              text-align: left;
              color: #000000;
              font-size: 25px;
              line-height: 1.2;
              margin: 0 0 9px 0;
              ${Tablet} {
                margin: 0 0 10px 0;
              }
              ${Desktop} {
                font-size: 35px;
                line-height: 1.57;
                margin: 0px 24px 45.6px 0px;
              }
            `}
          >
            {
              {
                en: 'View More Portfolios',
                'zh-cn': '其他组合',
                'zh-hk': '其他組合',
              }[intl.locale]
            }
          </div>

          // 其他组合card轮播图
          <ProductDetailsCarousel
            css={css`
              ${Tablet} {
                align-self: center;
                max-width: 100%;
              }
              ${Desktop} {
                max-width: 1190px;
                transform: translateX(-14px);
              }
            `}
            currentPid={product.data.pid}
          />
        </Container> */}
      </Container>
    </Layout>
  );
};

export default ProductDetails;
